import {
    ServerConnection,
    KernelManager,
    KernelMessage,
    KernelAPI
} from '@jupyterlab/services';
import { IKernelConnection } from '@jupyterlab/services/lib/kernel/kernel';
import { sleep } from './llm_client';

// start jupyter with
// jupyter server --NotebookApp.token=0b3042eefda2e3456501cc02290c3c1f12f1ac5d04c574c0 --NotebookApp.allow_origin='*' --NotebookApp.tornado_settings='{"headers": {"Access-Control-Allow-Headers": "baggage, authorization, sentry-trace, x-xsrftoken, Origin, Accept, Content-Type"}}'

interface State {
    kernelManager: null | KernelManager
}

const state : State = {
    kernelManager: null
}

export async function init() {
    const serverSettings = ServerConnection.makeSettings({
        //baseUrl: "http://localhost:8888/",
        //token: "0b3042eefda2e3456501cc02290c3c1f12f1ac5d04c574c0"
        baseUrl: "https://jupyter1.soclearn.org",
        token: "4feb3e63bfb310e7dd36702a338f616bf6257ed1f8072a2d"
    })
    state.kernelManager = new KernelManager({ serverSettings });

    //state.kernelManager.
}

export async function startKernel() {
    const kernel = await state.kernelManager!.startNew({ name: 'python' });
    kernel.statusChanged.connect((_, status) => {
        console.log(`Status: ${status}`);
    });

    // create custom dir so we don't step on each other feet
    // NOTE: this doesn't provide any security since anyone can just find
    // working dir from /proc, or even just get list of kernels and connect
    // to this kernel directly
    const r = await executeCode(kernel, `
path = !tr -cd '[:alnum:]' < /dev/urandom | fold -w30 | head -n1
path = path[0].strip()
!mkdir "{path}"
%cd "{path}"

import matplotlib.pyplot as plt`);
    console.log(r);

    return kernel
}

export async function executeCode(kernel: IKernelConnection, code: string) {
    const result: any[] = []
    if (kernel.isDisposed) return false;
    //console.log(kernel.status, kernel.isDisposed)
    const future = kernel.requestExecute({ code });
    future.onIOPub = (msg) => {
        if (msg.header.msg_type == 'status') return;
        if (msg.header.msg_type == 'execute_input') return;

        result.push(msg)
    };
    await future.done;

    return result
}

export default { init, startKernel, executeCode }

// demo

export async function jupyter_demo() {
    const serverSettings = ServerConnection.makeSettings({
        baseUrl: "http://localhost:8888/",
        token: "0b3042eefda2e3456501cc02290c3c1f12f1ac5d04c574c0"
    })
    const kernelManager = new KernelManager({ serverSettings });
    const kernel = await kernelManager.startNew({ name: 'python' });

    // ...........
    const log = console.log

    // Register a callback for when the kernel changes state.
    kernel.statusChanged.connect((_, status) => {
        log(`Status: ${status}`);
    });

    log('Executing code');
    let future = kernel.requestExecute({ code: 'a = 1' });
    // Handle iopub messages
    future.onIOPub = msg => {
        if (msg.header.msg_type !== 'status') {
        log(msg.content);
        }
    };
    await future.done;
    log('Execution is done');

    future = kernel.requestExecute({ code: 'a * 10' });
    // Handle iopub messages
    future.onIOPub = msg => {
        if (msg.header.msg_type !== 'status') {
            log(msg.content);
        }
    };
    await future.done;
    log('Execution is done');

    future = kernel.requestExecute({ code: `
import matplotlib.pyplot as plt
plt.plot(range(10), range(10))
` });
    // Handle iopub messages
    future.onIOPub = msg => {
        if (msg.header.msg_type !== 'status') {
            log(msg.content);
        }
    };
    await future.done;
    log('Execution is done');

    log('Send an inspect message');
    const request: KernelMessage.IInspectRequestMsg['content'] = {
        code: 'hello',
        cursor_pos: 4,
        detail_level: 0
    };
    const inspectReply = await kernel.requestInspect(request);
    log('Looking at reply');
    if (inspectReply.content.status === 'ok') {
        log('Inspect reply:');
        log(inspectReply.content.data);
    }

    log('Interrupting the kernel');
    await kernel.interrupt();

    log('Send an completion message');
    const reply = await kernel.requestComplete({ code: 'impor', cursor_pos: 4 });
    if (reply.content.status === 'ok') {
        log(reply.content.matches);
    }

    log('Restarting kernel');
    await kernel.restart();

    log('Shutting down kernel');
    await kernel.shutdown();

    log('Finding all existing kernels');
    const kernelModels = await KernelAPI.listRunning();
    log(kernelModels);
    if (kernelModels.length > 0) {
        log(`Connecting to ${kernelModels[0].name}`);
        kernelManager.connectTo({ model: kernelModels[0] });
    }
}